<div class="reservation-details h100 w100">
  <div class="reservation-details__configuration">
    <!-- <ng-scrollbar> -->
    <div [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.MaincontentTopBackgroundColor}">


      <div class="reservation-details__available-data">
        <!-- Need to change the styles based on Merchant portal -->
        @if (ls.operation==operationType.create) {
<div for="" class="reservation-details__title page-title" [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderBackgroundColor,
                                  'font-size': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderFontSize+'px',
                                  'text-align': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderPosition,
                                  'font-family': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderFont,
                                  'color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}"
            tabindex="0">
            @if (ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderText) {
              <span
              >{{ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderText}}</span>
            }
            @if (!ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderText) {
              <span
              >{{'letsMakeReservation' | translate}}</span>
            }
          </div>
        }
        @if (!ls.restaurantWidgetSettings$.value.WidgetCustomization.AllowNewReservations && specialMealList.length && ls.operation != operationType.edit) {
          <div class="reservation-details__event-selection">
            <dynamic-form [config]="reservationSelectionConfig" #reservationSelectionForm="dynamicForm">
            </dynamic-form>
          </div>
        }
        @if (isSpecialMealAvailable && specialMealList.length > 0 && ls.operation==operationType.create) {
          <div class="reservation-details__special-meal"
            >
            <div class="reservation-details__special-meal-header">
              <span for="" class="default-sub-header" tabindex="0">{{'availableMenu' | translate}}</span>
              @if (showPrepaymentIcon()) {
                <span for="" class="default-sub-header reservation-details__prepayment-legend">
                  <span class="icon-payments_FILL0_wght400_GRAD0_opsz48-1"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span
                class="path4"></span></span>
              {{'prePaymentNeeded' | translate}}</span>
            }
          </div>
          <!-- Need to change the styles based on Merchant portal -->
          @if (ls.operation==operationType.create) {
<div class="reservation-details__special-meal-row" [ngStyle]="{'font-family': ls.restaurantWidgetSettings$.value.WidgetCustomization.SpecialMealFont,
                              'font-size': ls.restaurantWidgetSettings$.value.WidgetCustomization.SpecialMealFontSize+'px'}">
              @for (specialMeal of specialMealList; track specialMeal) {
                <div class="reservation-details__special-meal-data selectable-data-bg"
                  [ngStyle]="{'background-color':(specialMeal.Id == selectedMeal.Id ? (ls.restaurantWidgetSettings$.value.WidgetCustomization.SMSelectedBackgroundColor ? ls.restaurantWidgetSettings$.value.WidgetCustomization.SMSelectedBackgroundColor : '#D9D9D9'): ls.restaurantWidgetSettings$.value.WidgetCustomization.SMBackgroundColor)}"
                  [ngClass]="{'no-cursor': specialMeal.Id == selectedMeal.Id}" (click)="selectedSpecialMeal(specialMeal)" (keydown.enter)="selectedSpecialMeal(specialMeal);$event.preventDefault(); $event.stopPropagation();"
                  tabindex="0">
                  <div class="default-sub-header reservation-details__special-meal-name"
                    [ngClass]="{'focused-sub-header':specialMeal.Id == selectedMeal.Id}"
                    [ngStyle]="{'font-size': ls.restaurantWidgetSettings$.value.WidgetCustomization.SpecialMealFontSize+'px'}">
                  {{specialMeal.Name}}</div>
                  <div class="helper-text reservation-details__special-meal-serves">
                    {{'serves'| translate}}
                    {{specialMeal.MinPartySize}} -
                    {{specialMeal.MaxPartySize}}
                    {{'people' | translate}}
                  </div>
                  <div class="helper-text-small" [ngClass]="{'view-price-cursor': specialMeal.Id == selectedMeal.Id}">
                    @if (specialMeal.CoverTypePrices?.length > 0) {
                      <span
                        [ngStyle]="{'color':ls.restaurantWidgetSettings$.value.WidgetCustomization.WidgetLinkColor}"
                        placement="bottom-left" (click)="selectedViewPricing(specialMeal)" tabindex="0"
                        (shown)="availableCoverTypePrices.length > 0" [ngbPopover]="popContent">{{'viewPrice' |
                      translate}}</span>
                    }
                    @if (specialMeal.CoverTypePrices?.length == 0) {
                      <span
                      class="reservation-details__price-data">{{specialMeal.Price ?  (ls.OperationCurrency) + (specialMeal.Price | currencyDecimalFormatter) : ''}}</span>
                    }
                  </div>
                  @if (specialMeal.DoesRequirePrepayment) {
                    <span [attr.aria-label]="'PrePaymentRequired'" class="icon-payments_FILL0_wght400_GRAD0_opsz48-1 reservation-details__prepayment-icon">
                      <span class="path1"></span><span class="path2"></span><span class="path3"></span><span
                    class="path4"></span></span>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>

    @if (ls.operation==operationType.edit) {
      <div class=" content-summary">
        <div class="page-title" style="padding-bottom: 10px;">{{'reservationSummary'| translate}}</div>
        <div class="reservation-details__reservation-data">
          @if (ls.editPartyData$.value.SpecialMeal && ls.editPartyData$.value.SpecialMeal.Name) {
            <span class="reservation-details__guest-info-text"
              >{{ls.editPartyData$.value.SpecialMeal.Name}}
              @if (ls.editPartyData$.value.SpecialMealAmount >0 && ls.editPartyData$.value.PrepaymentState != PartyPrepaymentState.Refunded) {
                <span
                  >-
                {{ls.restaurantWidgetSettings$.value.OperationCurrency}}{{ls.editPartyData$.value.SpecialMealAmount | currencyDecimalFormatter}}</span>
              }
            </span>
          }
          <span class="reservation-details__guest-info-text">{{ls.editPartyData$.value.Size}} {{'party' | translate}}</span>
          <span class="reservation-details__guest-info-text">{{ls.editPartyData$.value.ReservedFor |
          formatSettingsDate : ls.restaurantWidgetSettings$.value.DateFormat}}</span>
          <span class="reservation-details__guest-info-text">{{ls.editPartyData$.value.ReservedFor| localizeDate:'h:mm A'}}</span>
          @if (ls.editPartyData$.value.SeatingTypeId > 0) {
            <span class="reservation-details__guest-info-text"
              >{{ls.editPartyData$.value.SeatingTypeId | seatingTypeFilter :
              ls.restaurantWidgetSettings$.value.SeatingTypeList}}
              @if (ls.editPartyData$.value.RatePlanAmount > 0 && ls.editPartyData$.value.PrepaymentState != PartyPrepaymentState.Refunded) {
                <span
                  >-
                {{ls.restaurantWidgetSettings$.value.OperationCurrency}}{{ls.editPartyData$.value.RatePlanAmount | currencyDecimalFormatter}}</span>
              }
            </span>
          }
          <!--<span @if (paymentData && paymentData.RateplanAmountinfo && paymentData.RateplanAmountinfo >0) {>-
        {{paymentData.OperationCurrency}}{{paymentData.RateplanAmountinfo | currencyDecimalFormatter}}</span>
      </span> } -->
      @if (ls.editPartyData$.value.NoShowFeeAmount>0 && ls.editPartyData$.value.PrepaymentState == PartyPrepaymentState.None) {
        <span class="rereservation-details__guest-info-text"
          >
          {{'amount' |
        translate}}{{ls.restaurantWidgetSettings$.value.OperationCurrency}}{{ls.editPartyData$.value.NoShowFeeAmount | currencyDecimalFormatter}}</span>
      }
      <!-- <div style="padding: 0 12px;">
      <app-button [buttontype]="editButton" (valueChange)="goBackToReservation()"></app-button>
    </div> -->
  </div>
</div>
}
<!-- Need to change the styles based on Merchant portal -->
@if (ls.operation==operationType.edit) {
  <div class="page-title" style="padding-top: 20px;"
      [ngStyle]="{'font-size': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderFontSize+'px',
      'text-align': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderPosition,
      'font-family': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubHeaderFont}">{{'modifyReservation' | translate}}</div>
}
<div class="reservation-details__party-size-section">
  @if (showOtherDays && showRefreshText) {
    <a class="reservation-details__availability-text pl-4" (click)="availabilityText == 'refresh' ? onRefreshClick() : showOtherDaysAvailable()" tabindex="0" (keydown.enter)="availabilityText == 'refresh' ? onRefreshClick() : showOtherDaysAvailable();$event.preventDefault(); $event.stopPropagation();" style="">
      <em class="icon-Refresh reservation-details__refresh-icon"  [ngStyle]="{'color':ls.restaurantWidgetSettings$.value.WidgetCustomization.WidgetLinkColor}" style=""  (click)="onRefreshClick()" tabindex="0" (keydown.enter)="onRefreshClick();$event.preventDefault(); $event.stopPropagation();"></em>
      <span class="focused-sub-header"  [ngStyle]="{'color':ls.restaurantWidgetSettings$.value.WidgetCustomization.WidgetLinkColor}">{{availabilityText | translate}}</span>
    </a>
  }
  <dynamic-form [config]="reservationConfig" #reservationConfigForm="dynamicForm">
  </dynamic-form>

</div>
<div class="reservation-details__cover-type-section" [ngClass]="{'reservation-details__covers-no-padding': coverTypeConfig.length == 0 }">
  <!-- <div @if (coverTypeConfig.length > 0) { class="default-sub-header reservation-details__cover-type-title">
  {{'coverType' |
translate}}</div> } -->
@if (partySizeError) {
  <mat-error
    >
    *{{partySizeError}}
  </mat-error>
}
<dynamic-form [config]="coverTypeConfig" #coverTypeForm="dynamicForm">
</dynamic-form>
</div>
<!--Needed for show availability on other days -->
<div class="reservation-details__availability-days">
  @if (!showOtherDays && !showRefreshText && showSlots) {
    <a class="reservation-details__availability-text" (click)="availabilityText == 'refresh' ? onRefreshClick() : showOtherDaysAvailable()" tabindex="0" (keydown.enter)="availabilityText == 'refresh' ? onRefreshClick() : showOtherDaysAvailable();$event.preventDefault(); $event.stopPropagation();">
      <span class="focused-sub-header"  [ngStyle]="{'color':ls.restaurantWidgetSettings$.value.WidgetCustomization.WidgetLinkColor}">{{availabilityText | translate}}</span>
    </a>
  }
  @if (showOtherDays) {
    <div class="reservation-details__available-content">
      @if (otherAvailableDays.length > 5) {
        <span role="button" aria-pressed="false" (click)="navigateLeft()" class="icon-Left-Arrow"></span>
      }
      <div #availableDateContainer class="reservation-details__days-view">
        @for (days of otherAvailableDays; track days) {
          <div (click)="selectedDate(days)" class="reservation-details__date-view"
            [ngClass]="{'reservation-details__selected':(selectedDay && days.Id == selectedDay.Id)}" tabindex="0" (keydown.enter)="selectedDate(days);$event.preventDefault(); $event.stopPropagation();" >
            <span>{{days.value | localizeDate: 'DD'}}</span>
            <span>{{days.value | localizeDate: 'dddd'}}</span>
          </div>
        }
      </div>
      @if (otherAvailableDays.length > 5) {
        <span role="button" aria-pressed="false" (click)="navigateRight()" tabindex="0" (keydown.enter)="navigateRight();$event.preventDefault(); $event.stopPropagation();" class="icon-Right-Arrow"></span>
      }
    </div>
  }
</div>
</div>
@if (availableMealPeriods.length == 0 && !showSlots) {
  <div class="reservation-details__check-availability-btn">
    <app-button [buttontype]="CheckAvailabilityBtn" (valueChange)="CheckAvailability($event)"></app-button>
  </div>
}
@if (showSlots && !isDropdown) {
  <div id="timeBtnGroup" class="reservation-details__available-time" [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.MaincontentBottomBackgroundColor}">
    <span for="" class="default-sub-header reservation-details__time-title">{{'time' | translate}}</span>
    @if (timeBtnArray.length > 0 && ls.isMobileBrowser) {
      <div class="reservation-details__btn-row">
        <div class="reservation-details__mobile-time-list">
          @for (timeBtn of timeBtnArray; track timeBtn) {
            <div style="display: inline-block;">
              <app-button id="btn-{{timeBtn.Id}}"
                [buttontype]="timeBtn.Value | localizeDate: 'LT' | buttonInputFormater : buttonType.optionBtn :'btn-section default-form-field':false"
              (click)="selectedTimeArray(timeBtn)"></app-button>
            </div>
          }
        </div>
      </div>
    }
    @if (timeBtnArray.length > 0 && !ls.isMobileBrowser) {
      <div class="reservation-details__btn-row-desktop">
        @for (timeBtn of timeBtnArray; track timeBtn) {
          <app-button id="btn-{{timeBtn.Id}}"
            [buttontype]="timeBtn.Value | localizeDate: 'LT' | buttonInputFormater : buttonType.optionBtn :'btn-section default-form-field':false"
          (click)="selectedTimeArray(timeBtn)"></app-button>
        }
      </div>
    }
    @if (timeBtnArray.length == 0) {
      <div class="reservation-details__no-time-available default-form-field selectable-data-bg" tabindex="0"
        >
        {{'noSlotsAvailable' | translate}}
      </div>
    }
  </div>
}
@if (showSlots && isDropdown) {
  <div id="timeDropDownGroup" class="reservation-details__available-select-time" [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.MaincontentBottomBackgroundColor}">
    @if (timeBtnArray.length > 0) {
      <div class="reservation-details__time-selection">
        <dynamic-form [config]="timeBtnArrayConfig" #timeConfigForm="dynamicForm">
        </dynamic-form>
      </div>
    }
    @if (timeBtnArray.length == 0) {
      <div class="reservation-details__no-time-available default-form-field selectable-data-bg" tabindex="0"
        >
        {{'noSlotsAvailable' | translate}}
      </div>
    }
  </div>
}
<!-- </ng-scrollbar> -->
</div>
@if (timeBtnArray.length > 0 && showSlots) {
  <div class="reservation-details__actions">
    <!-- <app-button [buttontype]="previousButton"></app-button> -->
    <app-button [buttontype]="nextButton" (valueChange)="getSeatSelection()"></app-button>
  </div>
}
<ng-template #popContent>
  <div class="reservation-details__cover-type-popover">
    @for (coverType of availableCoverTypePrices; track coverType; let i = $index; let lastItem = $last) {
      <div class="reservation-details__cover-type-data toast-message"
        >
        <div class="reservation-details__cover-type-name">{{coverType.CoverTypeName}}</div>
        <div>{{ls.restaurantWidgetSettings$.value.OperationCurrency}} {{coverType.Price | currencyDecimalFormatter}}</div>
      </div>
    }
  </div>
</ng-template>
</div>
